import React, { useState, useEffect } from 'react';
import { fetchAllPromisedData } from '../../../../common/utils/methods/commonMethods/utilityMethod';
import ReceiptIndexList from './ReceiptIndexList';
import { endpoint } from '../../../../common/constant';
import ALoader from '../../../../common/a-loader';
import { Card, CardBody } from 'reactstrap';
import { getAuditDetails } from '../common';

const ReceiptIndex = ({
    buId,
    selectedTabValue
}) => {

    const [receiptIndexData, setReceiptIndexData] = useState({ fetching: false, data: [] });

    const fetchReceiptIndices = async () => {
        try {
            setReceiptIndexData(prev => ({ ...prev, fetching: true }));
            const resp = await fetchAllPromisedData(`${endpoint.receiptIndex.getReceiptIndices}/${buId}`, true);
            if (resp?.code === 200) {
                const data = resp?.data?.map((el, idx) => ({ ...el, srNo: idx + 1 }))
                setReceiptIndexData(prev => ({ ...prev, data }));
            }
        } catch (err) {
            console.error(err);
        } finally {
            setReceiptIndexData(prev => ({ ...prev, fetching: false }));
        }
    }

    useEffect(() => {
        buId &&  selectedTabValue?.key=="receiptIndex"&& fetchReceiptIndices();
    }, [buId, selectedTabValue?.key])

    if (selectedTabValue?.id !== 8) 
        return null;

    return (
        <>
            {receiptIndexData?.fetching && <ALoader position='fixed'/>}
            <Card className='ml-0'>
                <CardBody>
                    <div className='large-text color-grey-80'>Receipt Index</div>
                    <div className='mt-3' style={{border:'1px solid #E2E2E2'}}>
                    <ReceiptIndexList
                        receiptIndexData={receiptIndexData}
                    />
                    </div>
                    {receiptIndexData?.data&&receiptIndexData?.data.length>0&&getAuditDetails(receiptIndexData?.data[0].updatedBy,receiptIndexData?.data[0].updatedOn)}
                </CardBody>
            </Card>
        </>
    );
}

export default ReceiptIndex;